"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snackbarColor = void 0;
var color_1 = require("../color");
exports.snackbarColor = {
    pending: (0, color_1.hsla)(0, 0, 40, 1),
    success: (0, color_1.hsla)(123, 41, 45, 1),
    error: (0, color_1.hsla)(0, 100, 50, 1)
};
